<ng-template #sisalto>
  @if (matIcon) {
    <mat-icon>{{ matIcon }}</mat-icon>
  }
  <ng-content></ng-content>
</ng-template>
<!-- Valikon käynnistin lisää painikkeeseen neljä kuuntelijaa, joten se luodaan vain painikkeille, joilla on valikko -->
@if (matMenuTrigger) {
  <button class="{{ additionalClass }}" [ngClass]="dynamicClass" mat-icon-button type="button" [attr.style]="styles" [attr.aria-label]="ariaLabel || null" [matMenuTriggerFor]="matMenuTrigger" [matMenuTriggerData]="matMenuTriggerData" [disabled]="!!disabled" (click)="trackButton()">
    <ng-container [ngTemplateOutlet]="sisalto" />
  </button>
} @else {
  <button class="{{ additionalClass }}" [ngClass]="dynamicClass" mat-icon-button type="button" [attr.style]="styles" [attr.aria-label]="ariaLabel || null" [attr.aria-haspopup]="ariaHaspopup" [attr.aria-expanded]="ariaHaspopup ? 'false' : null" [disabled]="!!disabled" (click)="trackButton()">
    <ng-container [ngTemplateOutlet]="sisalto" />
  </button>
}
